export default __webpack_public_path__ + "static/media/meet4seat.6a98bd51.svg";